export const isDevEnv =
    process.env.REACT_APP_FIREBASE_CONFIG === 'staging' ||
    process.env.REACT_APP_FIREBASE_CONFIG === 'development' ||
    process.env.REACT_APP_FIREBASE_CONFIG === 'localhost'
